import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
    tone?: 'dark' | 'light'
}

export const Eyebrow: FC<EyebrowProps> = ({ children, className, tone = 'dark' }): ReactNode => {
    return (
        <p
            className={cn(
                'inline-flex items-center gap-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.2em]',
                tone === 'light' ? 'text-ember-soft' : 'text-ember',
                className
            )}
        >
            <span className={cn('size-1.5 rotate-45', tone === 'light' ? 'bg-ember-soft' : 'bg-ember')} aria-hidden='true' />
            {children}
        </p>
    )
}
